<template>
<div class="video-embed-coverfit-bg">
   
  <template v-if="type == 'vimeo'">
    <iframe       
      :src="src_vimeo" 
      frameborder="0" 
      allow="autoplay; fullscreen" 
      allowfullscreen
    ></iframe>
  </template>

  <template v-if="type == 'youtube'">
    <iframe       
      :src="src_youtube"
      type="text/html" 
      width="100%" 
      height="100%"
      allow="autoplay; fullscreen" 
      allowfullscreen
      autoplay
      frameborder="0"
    ></iframe>
  </template>

</div>
</template>

<script>
import mixins from '.././mixins.js'
export default {
  mixins: [ mixins.generic ],
  props: [
    'type', 
    'video_slug',     
  ],
  data(){ return {
         

  }},
  computed:{
    
    src_youtube(){
      
      var sound = 'mute=1'
      //if( this.settings.sound === true ) sound = 'mute=0'
      
      var controls = 'controls=0'
      if( this.settings.controls === true ) controls = 'controls=1'
      
      var s = 'https://www.youtube.com/embed/'+ this.video_slug +'?autoplay=1&'+controls+'&loop=1&playlist='+ this.video_slug +'&'+sound+'&modestbranding=1&version=3&rel=0&showinfo=0&origin=' + this.site_base_url
      return s
    },

    src_vimeo(){
      
      var sound = 'muted=1'
      //if( this.settings.sound === true ) sound = 'muted=0'
      
      var background = 'background=1'
      //if( this.settings.controls === true ) background = 'background=0'

      var s = 'https://player.vimeo.com/video/'+ this.video_slug + '?autoplay=1&'+sound+'&loop=1&title=0&portrait=0&byline=0&title=0&autopause=0&'+background+'&quality=720p'
      return s
    },
    
  },
  methods: {
        
    
  },  
  mounted(){
    
  },
  created(){
    
    

  },

  destroyed(){
    
    

  },

}
</script>


// WEBPACK FOOTER //
// src/components/VideoEmbedCoverfitBg.vue